// import React, { useState } from "react";
// import PropTypes from "prop-types";
// import { Modal } from "../../Modal/Modal";
// import styles from "./AttentionModal.module.css";
// import Button from "../../Button/Button";
// import { Link } from "react-router-dom";
// import { AccountContainer } from "../../../hooks/useAccount";

// const AttentionModal = ({ isOpen, onCloseButtonClick, airline }) => {
//   const { login } = AccountContainer.useContainer();

//   const footer = <Button label="Close Login" onClick={onCloseButtonClick} />;
//   const [employeeNumber, setEmployeeNumber] = useState("");
//   const [password, setPassword] = useState("");
//   const [errorMessage, setErrorMessage] = useState(null);
//   const [touched, setTouched] = useState({
//     employeeNumber: false,
//     password: false,
//   });

//   const [alertType, setAlertType] = useState("danger");

//   const showError = (message, type = "danger") => {
//     setErrorMessage(message);
//     setAlertType(type);
//   };

//   const handleBlur = (field) => {
//     setTouched({ ...touched, [field]: true });
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "employeeNumber") {
//       setEmployeeNumber(value);
//     } else if (name === "password") {
//       setPassword(value);
//     }
//   };

//   const validate = () => {
//     return {
//       employeeNumber: employeeNumber.length === 0,
//       password: password.length === 0,
//     };
//   };

//   const errors = validate();

//   const shouldMarkError = (field) => {
//     return touched[field] && errors[field];
//   };

//   const handleNonUPS = async (e) => {
//     e.preventDefault();
//     showError("Invalid username or password!");
//   };

//   const handleSubmit = async (e) => {
//     setErrorMessage(null);
//     e.preventDefault();
//     if (!errors.employeeNumber && !errors.password) {
//       try {
//         await login({ employeeNumber: employeeNumber, password });
//         window.location.href = window.location.href;
//         onCloseButtonClick(); // Close the modal after successful login
//       } catch (error) {
//         showError("Invalid username or password!");
//       }
//     } else {
//       setTouched({ employeeNumber: true, password: true });
//     }
//   };

//   let UPS = (
//     <>
//       <p>You must log in before subscribing.</p>
//       <p>
//         New UPS pilots receive a welcome letter from us with instructions and an
//         email with a temporary password. Please use that password to log in
//         below.
//       </p>
//       <p>
//         If you are not a new hire or did not receive the welcome and/or password
//         reset email, please reach out to us at
//         <Link to="mailto:tech@bidpro.com"> tech@bidpro.com </Link>
//         and we are happy to assist.
//       </p>
//       <p>
//         After logging in, you will be able to select your BidPro subscription
//         and complete the sign up process.
//       </p>
//       {errorMessage && (
//         <div className={`${styles.customAlert}`} role="alert">
//           {errorMessage}
//         </div>
//       )}
//       <form className={styles.form} id="loginForm" onSubmit={handleSubmit}>
//         <h3 className={styles.h3}>Login</h3>
//         <div className="mb-3">
//           <input
//             type="text"
//             name="employeeNumber"
//             className={`form-control ${shouldMarkError("employeeNumber") ? styles.invalid : ""} `}
//             placeholder="Employee Number"
//             value={employeeNumber}
//             onChange={handleChange}
//             onBlur={() => handleBlur("employeeNumber")}
//           />
//           {shouldMarkError("employeeNumber") && (
//             <div className={styles.errorText}>Please enter username.</div>
//           )}
//         </div>
//         <div className="mb-3">
//           <input
//             type="password"
//             name="password"
//             className={`form-control ${shouldMarkError("password") ? styles.invalid : ""}`}
//             placeholder="Password"
//             value={password}
//             onChange={handleChange}
//             onBlur={() => handleBlur("password")}
//           />
//           {shouldMarkError("password") && (
//             <div className={styles.errorText}>Please enter a password.</div>
//           )}
//         </div>
//         <div>
//           <button className="btn" id={styles.btn} type="submit">
//             Login
//           </button>
//         </div>
//       </form>
//     </>
//   );

//   let children = (
//     <>
//       {errorMessage && (
//         <div className={`${styles.customAlert}`} role="alert">
//           {errorMessage}
//         </div>
//       )}
//       <form className={styles.form} id="loginForm" onSubmit={handleNonUPS}>
//         <h3 className={styles.h3}>Login</h3>
//         <div className="mb-3">
//           <input
//             type="text"
//             name="employeeNumber"
//             className={`form-control ${shouldMarkError("employeeNumber") ? styles.invalid : ""} `}
//             placeholder="Employee Number"
//             value={employeeNumber}
//             onChange={handleChange}
//             onBlur={() => handleBlur("employeeNumber")}
//           />
//           {shouldMarkError("employeeNumber") && (
//             <div className={styles.errorText}>Please enter username.</div>
//           )}
//         </div>
//         <div className="mb-3">
//           <input
//             type="password"
//             name="password"
//             className={`form-control ${shouldMarkError("password") ? styles.invalid : ""}`}
//             placeholder="Password"
//             value={password}
//             onChange={handleChange}
//             onBlur={() => handleBlur("password")}
//           />
//           {shouldMarkError("password") && (
//             <div className={styles.errorText}>Please enter a password.</div>
//           )}
//         </div>
//         <div>
//           <button className="btn" id={styles.btn} type="submit">
//             Login
//           </button>
//         </div>
//       </form>
//     </>
//   );

//   return (
//     <>
//       {airline === "UPS" && (
//         <div className="container">
//           <Modal
//             isOpen={isOpen}
//             className="modal"
//             header="Attention UPS pilots!"
//             children={UPS}
//             footer={footer}
//           />
//         </div>
//       )}

//       {airline === "ALASKA" && (
//         <div className="container">
//           <Modal
//             isOpen={isOpen}
//             className="modal"
//             header="Attention Alaska pilots!"
//             children={children}
//             footer={footer}
//           />
//         </div>
//       )}

//       {airline === "AMERICAN" && (
//         <div className="container">
//           <Modal
//             isOpen={isOpen}
//             className="modal"
//             header="Attention American pilots!"
//             children={children}
//             footer={footer}
//           />
//         </div>
//       )}
//     </>
//   );
// };

// AttentionModal.propTypes = {
//   isOpen: PropTypes.bool.isRequired,
//   onCloseButtonClick: PropTypes.func.isRequired,
//   airline: PropTypes.string,
// };

// export default AttentionModal;

import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal } from "../../Modal/Modal";
import styles from "./AttentionModal.module.css";
import Button from "../../Button/Button";
import { Link } from "react-router-dom";
import { AccountContainer } from "../../../hooks/useAccount";

const AttentionModal = ({ isOpen, onCloseButtonClick, airline }) => {
  const { login } = AccountContainer.useContainer();

  const footer = <Button label="Close Login" onClick={onCloseButtonClick} />;
  const [employeeNumber, setEmployeeNumber] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [touched, setTouched] = useState({
    employeeNumber: false,
    password: false,
  });

  const [alertType, setAlertType] = useState("danger");

  const showError = (message, type = "danger") => {
    setErrorMessage(message);
    setAlertType(type);
  };

  const handleBlur = (field) => {
    setTouched({ ...touched, [field]: true });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "employeeNumber") {
      setEmployeeNumber(value);
    } else if (name === "password") {
      setPassword(value);
    }
  };

  const validate = () => {
    return {
      employeeNumber: employeeNumber.length === 0,
      password: password.length === 0,
    };
  };

  const errors = validate();

  const shouldMarkError = (field) => {
    return touched[field] && errors[field];
  };

  const handleNonUPS = async (e) => {
    e.preventDefault();
    showError("Invalid username or password!");
  };

  const handleSubmit = async (e) => {
    setErrorMessage(null);
    e.preventDefault();
    if (!errors.employeeNumber && !errors.password) {
      try {
        await login({ employeeNumber: employeeNumber, password });
        window.location.href = window.location.href;
        onCloseButtonClick(); // Close the modal after successful login
      } catch (error) {
        showError("Invalid username or password!");
      }
    } else {
      setTouched({ employeeNumber: true, password: true });
    }
  };

  let UPS = (
    <>
      <p>You must log in before subscribing.</p>
      <p>
        New UPS pilots receive a welcome letter from us with instructions and an
        email with a temporary password. Please use that password to log in
        below.
      </p>
      <p>
        If you are not a new hire or did not receive the welcome and/or password
        reset email, please reach out to us at
        <Link to="mailto:tech@bidpro.com"> tech@bidpro.com </Link>
        and we are happy to assist.
      </p>
      <p>
        After logging in, you will be able to select your BidPro subscription
        and complete the sign up process.
      </p>
      {errorMessage && (
        <div className={`${styles.customAlert}`} role="alert">
          {errorMessage}
        </div>
      )}
      <form className={styles.form} id="loginForm" onSubmit={handleSubmit}>
        <h3 className={styles.h3}>Login</h3>
        <div className="mb-3">
          <input
            type="text"
            name="employeeNumber"
            className={`form-control ${
              shouldMarkError("employeeNumber") ? styles.invalid : ""
            } `}
            placeholder="Employee Number"
            value={employeeNumber}
            onChange={handleChange}
            onBlur={() => handleBlur("employeeNumber")}
          />
          {shouldMarkError("employeeNumber") && (
            <div className={styles.errorText}>Please enter username.</div>
          )}
        </div>
        <div className="mb-3">
          <input
            type="password"
            name="password"
            className={`form-control ${
              shouldMarkError("password") ? styles.invalid : ""
            }`}
            placeholder="Password"
            value={password}
            onChange={handleChange}
            onBlur={() => handleBlur("password")}
          />
          {shouldMarkError("password") && (
            <div className={styles.errorText}>Please enter a password.</div>
          )}
        </div>
        <div>
          <button className="btn" id={styles.btn} type="submit">
            Login
          </button>
        </div>
      </form>
    </>
  );

  let children = (
    <>
      {errorMessage && (
        <div className={`${styles.customAlert}`} role="alert">
          {errorMessage}
        </div>
      )}
      <form className={styles.form} id="loginForm" onSubmit={handleNonUPS}>
        <h3 className={styles.h3}>Login</h3>
        <div className="mb-3">
          <input
            type="text"
            name="employeeNumber"
            className={`form-control ${
              shouldMarkError("employeeNumber") ? styles.invalid : ""
            } `}
            placeholder="Employee Number"
            value={employeeNumber}
            onChange={handleChange}
            onBlur={() => handleBlur("employeeNumber")}
          />
          {shouldMarkError("employeeNumber") && (
            <div className={styles.errorText}>Please enter username.</div>
          )}
        </div>
        <div className="mb-3">
          <input
            type="password"
            name="password"
            className={`form-control ${
              shouldMarkError("password") ? styles.invalid : ""
            }`}
            placeholder="Password"
            value={password}
            onChange={handleChange}
            onBlur={() => handleBlur("password")}
          />
          {shouldMarkError("password") && (
            <div className={styles.errorText}>Please enter a password.</div>
          )}
        </div>
        <div>
          <button className="btn" id={styles.btn} type="submit">
            Login
          </button>
        </div>
      </form>
    </>
  );

  return (
    <>
      {airline === "UPS" && (
        <div className="container">
          <Modal
            isOpen={isOpen}
            className="modal"
            header="Attention UPS pilots!"
            children={UPS}
            footer={footer}
          />
        </div>
      )}

      {airline === "ALASKA" && (
        <div className="container">
          <Modal
            isOpen={isOpen}
            className="modal"
            header="Attention Alaska pilots!"
            children={children}
            footer={footer}
          />
        </div>
      )}

      {airline === "AMERICAN" && (
        <div className="container">
          <Modal
            isOpen={isOpen}
            className="modal"
            header="Attention American pilots!"
            children={children}
            footer={footer}
          />
        </div>
      )}
    </>
  );
};

AttentionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseButtonClick: PropTypes.func.isRequired,
  airline: PropTypes.string,
};

export default AttentionModal;
